import { POSITION_ORDER } from "constants/CONSTANTS";
import {
  USER_REQUEST,
  FETCH_USERS_SUCCESS,
  FETCH_ELMS_FOR_FEATURE_SUCCESS,
  APPEND_ELMS_FOR_FEATURE_SUCCESS,
  FETCH_ELMS_BY_GROUPS_SUCCESS,
  GET_USER_SUCCESS,
  CREATE_USER_SUCCESS,
  UPDATE_USER_SUCCESS,
  DELETE_USER_SUCCESS,
  USER_FAILURE,
  UPDATE_STATUS_USER_SUCCESS,
  FETCH_SUPERIORS_SUCCESS,
} from "../action/types";

const initialState = {
  users: [],
  officers: [],
  officersByGroups: {},
  superiors: [],
  total: 0,
  currentUser: null,
  loading: false,
  error: null,
};

const userReducer = (state = initialState, action) => {
  const { type, payload } = action;

  const sortUsers = (users) =>
    [...users].sort((a, b) => {
      const orderA = POSITION_ORDER[a.position] ?? 99;
      const orderB = POSITION_ORDER[b.position] ?? 99;
      if (orderA !== orderB) return orderA - orderB;
      return b.weight - a.weight;
    });

  switch (type) {
    case USER_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_USERS_SUCCESS:
      return {
        ...state,
        loading: false,
        users: payload?.data ?? (Array.isArray(payload) ? payload : []),
        total: payload?.total ?? (Array.isArray(payload) ? payload.length : 0),
      };
    case FETCH_ELMS_FOR_FEATURE_SUCCESS:
      return {
        ...state,
        loading: false,
        officers: payload?.data ?? (Array.isArray(payload) ? payload : []),
      };
    case APPEND_ELMS_FOR_FEATURE_SUCCESS:
      const newOfficers =
        payload?.data ?? (Array.isArray(payload) ? payload : []);
      return {
        ...state,
        loading: false,
        officers: [...state.officers, ...newOfficers],
      };
    case FETCH_ELMS_BY_GROUPS_SUCCESS:
      return {
        ...state,
        loading: false,
        officersByGroups: payload ?? {},
      };

    case FETCH_SUPERIORS_SUCCESS:
      return {
        ...state,
        loading: false,
        superiors: payload?.data ?? (Array.isArray(payload) ? payload : []),
      };

    case GET_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        currentUser: payload,
        users: state.users.map((item) =>
          item.id === payload?.id ? payload : item,
        ),
      };

    case CREATE_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        users: sortUsers([payload, ...state.users]),
        total: state.total + 1,
      };

    case UPDATE_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        users: sortUsers(
          state.users.map((item) => (item.id === payload?.id ? payload : item)),
        ),
      };

    case DELETE_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        users: state.users.filter((item) => item.id !== payload),
        total: state.total - 1,
      };

    case USER_FAILURE:
      return {
        ...state,
        loading: false,
        error: payload,
      };
    case UPDATE_STATUS_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        users: state.users.map((item) =>
          item.id === payload?.id ? payload : item,
        ),
      };

    default:
      return state;
  }
};

export default userReducer;
